import { Link } from "react-router-dom";
import { Mail, Globe, ShieldCheck } from "lucide-react";
import { LogoMark, Wordmark } from "@/components/Logo";
import { FadeUp } from "@/components/Reveal";
import { scrollToId } from "@/lib/api";
import { SITE } from "@/content";

export const Footer = () => (
  <footer data-testid="footer-section" className="relative bg-[#120204] border-t border-[#D4AF37]/20 pt-20 pb-10 overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(700px 300px at 50% 0%, rgba(212,175,55,0.08), transparent 65%)" }}
    />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <FadeUp className="flex flex-col items-center text-center gap-6">
        <LogoMark size={56} />
        <h2 className="font-serif-lux text-4xl sm:text-5xl text-[#FAF6F0]">
          Sai Grand <span className="italic gold-text">Celebrations</span>
        </h2>
        <p className="max-w-md text-sm font-light text-[#A39791] leading-relaxed">
          A majestic wedding mandap and celebration hall — opening shortly. Early enquiries are
          warmly welcomed.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 mt-2">
          <a
            data-testid="footer-email-link"
            href={`mailto:${SITE.email}`}
            className="flex items-center gap-2.5 text-sm text-[#F3E5AB] hover:text-[#D4AF37] transition-colors duration-300"
          >
            <Mail size={15} className="text-[#D4AF37]" /> {SITE.email}
          </a>
          <span className="flex items-center gap-2.5 text-sm text-[#F3E5AB]/80">
            <Globe size={15} className="text-[#D4AF37]" /> {SITE.domain}
          </span>
        </div>
        <nav className="flex flex-wrap justify-center gap-7 mt-4">
          {SITE.navLinks.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-[11px] uppercase tracking-[0.24em] text-[#A39791] hover:text-[#F3E5AB] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </FadeUp>

      <div className="mt-14 pt-7 border-t border-[#D4AF37]/15 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-[11px] tracking-[0.14em] text-[#A39791]">
          © {new Date().getFullYear()} Sai Grand Celebrations · saigrandcelebrations.in
        </p>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#A39791]/70 hover:text-[#D4AF37] transition-colors duration-300"
        >
          <ShieldCheck size={13} /> Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
